'use client';

import { AlertTriangle, LockKeyholeOpen } from 'lucide-react';
import { useModalConfirmStore } from '@/stores/useModalConfirmStore';
import IconAdaptive from '@/components/IconAdaptive';
import { blockSound } from '@/(routers)/boards/editor/block/blockSound';

interface Props {
    onConfirm: () => void;
}

export default function BoardBlockSyncBanner({ onConfirm }: Props) {
    const handleRestoreBlocks = () => {
        useModalConfirmStore.getState().openModalConfirm({
            id: 'restore-blocks',
            message: 'ブロックのロックを解除しますか？',
            subMessage: 'コードの変更は破棄されます。',
            confirmLabel: 'ロックを解除する',
            cancelLabel: 'キャンセル',
            variant: 'warning',
            onConfirm: () => {
                onConfirm();
                blockSound.queue('board-sync');
            },
        });
    };

    return (
        <div className="absolute top-2 right-4 z-30 flex items-center gap-2 px-4 py-2 bg-yellow-50 border border-yellow-300">
            <div className="flex items-center gap-2">
                <IconAdaptive Icon={AlertTriangle} strokeWidth={1.5} baseSize={22} className="text-yellow-500" />
                <span className="font-notojp font-normal text-xs text-color-base whitespace-nowrap">
                    コードが編集されたため、ブロックはロックされています。
                </span>
            </div>
            <button
                onClick={handleRestoreBlocks}
                className="flex items-center gap-1.5 px-3 py-1 rounded-md font-cantarell text-xs text-white bg-yellow-400 hover:opacity-80 transition-colors whitespace-nowrap"
            >
                <IconAdaptive
                    Icon={LockKeyholeOpen}
                    strokeWidth={1.5}
                    baseSize={18}
                    className="text-color-white-base"
                />
                ロックを解除する
            </button>
        </div>
    );
}
